module.exports = __webpack_public_path__ + "media/pudgling.8df1d108.webm";